export default __webpack_public_path__ + "static/media/photo--sm--james-1.09ff6aeb.jpg";